export default "__VITE_ASSET__$eOD2XIH__"